'use strict'

function loadScript(src) {
    return new Promise(function(resolve, reject) {
        let element;

        if (src.endsWith('.css')) {
            element = document.createElement('link');
            element.href = src;
            element.rel = 'stylesheet';
        } else if (src.endsWith('.js')) {
            element = document.createElement('script');
            element.src = src;
            element.async = true;
        } else {
            return reject(new Error('Unsupported resource type: ' + src));
        }

        element.onload = () => resolve(src);
        element.onerror = () => reject(new Error('Error while lazy loading resource: ' + src));

        document.head.appendChild(element);
    });
}


/**
 * Retrieves owl scripts data, excluding already loaded scripts
 * @param selector
 * @returns {string[]}
 */
export function getUnloadedScripts(selector){
    const currentScripts = Array.from(document.querySelectorAll('script')).map(script => script.src);
    const scriptsData = document.querySelector(selector);
    if(!scriptsData)
        return [];

    const owlScripts = [scriptsData.dataset.urlJs, scriptsData.dataset.urlCss].filter(function(url){
        return (url && !currentScripts.includes(url));
    });

    scriptsData.remove();
    return owlScripts;
}


/**
 * Function that loads an array of scripts.
 * Useful for lazyloading purposes
 * @param scriptUrls
 * @returns {Promise<unknown[]>}
 */
export function promiseAllScripts(scriptUrls, callback){
    //STEP 1 -- Use a promise all to load every script, then initialize them as usual
    return Promise.all(scriptUrls.map(loadScript))
        .then(() => {
            if (typeof callback === 'function')
                callback();
        })
        .catch(error => {
            console.error('Error while loading scripts. Error: ', error.message);
        });
}


// WEBPACK FOOTER //
// ./assets/scripts/performance/helpers/scriptLoader.js